/** @jsxImportSource solid-js */

import { Component, onMount } from 'solid-js';
import { defineSolidAuthImage, defineSolidIconButton } from '@tcweb/connect-ui';

export interface IAttachmentListItemProps {
  readonly attachment: {
    readonly imgUrl?: string;
    readonly type: string;
    readonly title: string;
  };
  readonly index: number;
  onRemoveAttachment?(index: number): void;
  readonly accessToken?: string;
}

const AttachmentListItem: Component<IAttachmentListItemProps> = (props) => {
  // Initialize the web components
  onMount(() => {
    defineSolidAuthImage();
    defineSolidIconButton();
  });

  const getIconClass = (): string => {
    if (props.attachment.imgUrl) return '';
    if (props.attachment.type === 'VIEW' || props.attachment.type === 'VIEW2D')
      return 'icon-font i16 tc-icon-views';
    if (props.attachment.type === 'FILE') return 'icon-font i16 tc-icon-file';
    if (props.attachment.type === 'URL') return 'icon-font i16 tc-icon-link';
    return '';
  };

  const handleRemove = (event: MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();

    const customEvent = new CustomEvent('attachment-remove', {
      detail: {
        index: props.index,
        originalEvent: event,
      },
      bubbles: true,
    });
    (event.target as HTMLElement)?.dispatchEvent(customEvent);

    if (props.onRemoveAttachment) {
      props.onRemoveAttachment(props.index);
    }
  };

  return (
    <li class="list-item group" data-index={props.index}>
      <div class="group-items px-0">
        {props.attachment.imgUrl && (
          <i>
            {/* @ts-expect-error - tc-auth-image is a web component defined at runtime */}
            <tc-auth-image
              src={props.attachment.imgUrl}
              class="i16"
              alt=""
              access-token={props.accessToken}
            />
          </i>
        )}
        {!props.attachment.imgUrl && <i class={getIconClass()} />}

        <div class="block">
          <div class="text-ellipsis">
            <small>{props.attachment.title}</small>
          </div>
        </div>
        {/* @ts-expect-error - tc-icon-button is a web component defined at runtime */}
        <tc-icon-button
          icon="icon-font tc-icon-content-close"
          size="icon-small"
          color="tertiary"
          class="ml-auto"
          onClick={handleRemove}
          classes="icon-margin"
        />
      </div>
    </li>
  );
};

export default AttachmentListItem;
